(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("7oN3a", function(module, exports) {
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
const $5630d2a021cd5f07$var$links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a");
$5630d2a021cd5f07$var$links.forEach((link)=>{
    const image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img');
    if (!image) return;
    !link.hasAttribute("data-fancybox") && link.setAttribute("data-fancybox", "");
    const alignsClasses = [
        "aligncenter",
        "alignright",
        "alignleft"
    ];
    alignsClasses.forEach((align)=>{
        if (!image.classList.contains(align)) return;
        image.classList.remove(align);
        link.classList.add(align);
    });
});

});

})();
//# sourceMappingURL=entry-content-fancybox-image.00ca4624.js.map
